import { render, staticRenderFns } from "./AdjustOntologyEnts.vue?vue&type=template&id=83a335d2&scoped=true&"
import script from "./AdjustOntologyEnts.vue?vue&type=script&lang=ts&"
export * from "./AdjustOntologyEnts.vue?vue&type=script&lang=ts&"
import style0 from "./AdjustOntologyEnts.vue?vue&type=style&index=0&id=83a335d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a335d2",
  null
  
)

export default component.exports